import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { ClientNow } from "@/features/booking/modules/client-now/client-now";
import { ClientTabPage } from "@/features/booking/modules/client-page/client-tab-page";
import { ProgressBreakdown } from "@/features/progress/modules/progress-breakdown/progress-breakdown";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(private)/trainees/$clientId/")({
  // The `$clientId` layout route already fetched the client's name, so reuse it rather than ask twice.
  loader: async ({ parentMatchPromise }) => {
    const parent = await parentMatchPromise;
    return { crumb: parent.loaderData?.crumb ?? m.booking_client_page_crumb() };
  },
  validateSearch: z.object({ bookingId: z.string().optional() }),
  component: ClientRoute,
});

function ClientRoute() {
  const { clientId } = Route.useParams();
  // The progress card rides in the overview's right column: a trainer opening a client sees the
  // latest reading of every metric beside the visits, above the approval.
  return (
    <ClientTabPage
      clientId={clientId}
      tab="overview"
      summary={<ClientNow clientId={clientId} />}
      aside={<ProgressBreakdown clientId={clientId} />}
    />
  );
}
